import React from 'react';
import debounce from 'lodash/debounce';
import styled from 'styled-components';
import theme from 'shared/assets/style/theme';

const Button = props => {
  const {
    containerStyle = {},
    imageStyle = {},
    label,
    imageSource,
    onClick,
    objectFit,
    textStyle,
    disabled,
    isDebounce,
    textStroke,
  } = props;

  const onClickHander = debounce(
    () => {
      onClick();
    },
    isDebounce ? 200 : 0
  );

  return (
    <ButtonWrapper onClick={() => (!disabled ? onClickHander() : null)} containerStyle={containerStyle}>
      <ButtonImage imageSource={imageSource} imageStyle={imageStyle} objectFit={objectFit} />
      <ButtonText disabled={disabled} textStroke={textStroke} textStyle={textStyle}>
        {label}
      </ButtonText>
    </ButtonWrapper>
  );
};

export default Button;

const ButtonWrapper = styled.div`
  justify-content: center;
  align-items: center;
  display: flex;
  width: 180px;
  text-align: center;
  cursor: pointer;
  ${({ containerStyle }) => containerStyle}
`;

const ButtonImage = styled.img.attrs(({ imageSource }) => ({
  src: imageSource,
}))`
  position: absolute;
  width: 180px;
  object-fit: ${({ objectFit }) => objectFit || 'contain'};
  z-index: 1;
  ${({ imageStyle }) => imageStyle}
`;

const ButtonText = styled.p`
  position: absolute;
  font-size: 24px;
  font-weight: 700;
  margin: 0 auto !important;
  z-index: 2;
  color: ${theme.palette.common[1]};
  text-stroke: 1px
    ${({ disabled, textStroke }) => (disabled ? theme.palette.secondary[21] : textStroke || theme.palette.secondary[0])};
  -webkit-text-stroke: 1px
    ${({ disabled, textStroke }) => (disabled ? theme.palette.secondary[21] : textStroke || theme.palette.secondary[0])};
  ${({ textStyle }) => textStyle}
`;

